import React from "react";
const IconFacebook = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M.545 2.73C0 3.8 0 5.2 0 8v4c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C3.8 20 5.2 20 8 20h1.914v-7.582H7.078V9.226h2.836V6.792c0-2.769 1.668-4.298 4.22-4.298 1.221 0 2.5.216 2.5.216v2.718h-1.409c-1.387 0-1.82.852-1.82 1.725v2.072h3.098l-.495 3.194h-2.603v7.578c1.897-.015 2.991-.097 3.865-.542a5 5 0 0 0 2.185-2.185C20 16.2 20 14.8 20 12V8c0-2.8 0-4.2-.545-5.27A5 5 0 0 0 17.27.545C16.2 0 14.8 0 12 0H8C5.2 0 3.8 0 2.73.545A5 5 0 0 0 .545 2.73Z"
    />
  </svg>
);
export default IconFacebook;
